import {BaseDTO} from '../../../common/models/BaseDTO';
import {NameValueDTO} from '../../../common/models/NameValueDTO';
import {FileDTO} from '../FileDTO';

export class CaseHospitalFileLinkDTO extends BaseDTO {
  caseHospitalId: number | bigint;
  file: FileDTO;
  workmanCompensationFundDocumentation: NameValueDTO;
  accidentRoadFundDocumentation: NameValueDTO;
}
